/*------------------------------------*\
	#TABLE
\*------------------------------------*/

let tablePosition = [];

const initTable = () => {
	const tables = document.querySelectorAll('.js-table');

	if (tables) {
		tables.forEach((table, index) => {
			const tableContainer = table.closest('.js-table-container'),
				prevElement = tableContainer.querySelector('.js-table-control-prev'),
				nextElement = tableContainer.querySelector('.js-table-control-next'),
				breakpointTablet = 1024;

			tablePosition.push(0);

			if (window.innerWidth < breakpointTablet) {

				prevElement.addEventListener('click', function (event) {
					iterateTableElements(table, '-', nextElement, index);

					if (tablePosition[index] <= 0) {
						prevElement.classList.add('is-disabled');
					} else {
						nextElement.classList.remove('is-disabled');
					}

				});

				nextElement.addEventListener('click', function (event) {

					if (tablePosition[index] >= 0) {
						prevElement.classList.remove('is-disabled');
						iterateTableElements(table, '+', nextElement, index);
					}

				});

			}

		})

	}

}

function iterateTableElements(table, mode, nextElement, tableIndex) {
	const tableDatas = table.querySelectorAll('.js-table-body td'),
		tableHeaders = table.querySelectorAll('.js-table-head th');
	let columnAmountInRow = 0;

	if (table) {
		columnAmountInRow = table.rows[0].cells.length;

		if (mode === '-') {
			tablePosition[tableIndex] -= 100;
		}

		if (mode === '+') {
			tablePosition[tableIndex] += 100;
		}

		tableHeaders.forEach((tableHeader, index) => {
			if (index > 0) {
				tableHeader.style.transform = "translateX(-" + tablePosition[tableIndex] + "%)";
			}

		});

		tableDatas.forEach(tableData => {
			let isFixed = tableData.classList.contains('js-table-column-fixed');

			if (!isFixed) {
				tableData.style.transform = "translateX(-" + tablePosition[tableIndex] + "%)";
			}

		});


		if (tablePosition[tableIndex] >= ((columnAmountInRow - 2) * 100)) {
			nextElement.classList.add('is-disabled');
		} else {
			nextElement.classList.remove('is-disabled');
		}

	}

}

window.addEventListener('DOMContentLoaded', (event) => {
	initTable();
});

window.addEventListener("resize", (event) => {
	initTable();
});
